<template>
  <div class="common-card">
    <modal-refund-filter
      :filter_receipt_id.sync="filter_receipt_id"
      :filter_customer_id.sync="filter_customer_id"
      :filter_project_id.sync="filter_project_id"
      :receipt-options="handleAdminReceiptOptions"
      :customer-options="customerOptions"
      :project-options="projectOptions"
      @refetch-data="refetchData"
    />
    <!-- :filter_payment_method_id.sync="filter_payment_method_id"=
      :paymentMethodOptions="paymentMethodOptions" -->

    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon
              class="mr-50"
              icon="fa-solid fa-file-invoice-dollar"
            />
            退款
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋退款"
          />
          <b-button
            variant="primary"
            class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
            @click="$bvModal.show('modal-refund-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <b-button class="mobile-w100" :to="{ name: getCreateRefundRoute }"
          v-if="ability.can('create', 'refunds')"
          >
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增退款</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">

      <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
        <b-table
          ref="refRefundListTable"
          class="position-relative"
          :items="fetchRefunds"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: type -->
          <template #cell(payment_method)="data">
            {{ data.item.payment_method && data.item.payment_method.name }}
          </template>


          <!-- Column: refund_items -->
          <template #cell(show_details)="row">
            <b-button
              v-if="row.item.refund_items"
              size="sm"
              @click="row.toggleDetails"
              class="mr-2"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
          </template>
          <template #row-details="row">
            <b-row
              class="p-2 backgroundColor5 mb-1"
              v-for="(refund, index) in row.item.refund_items"
              :key="`refund${index}`"
            >
              <b-col cols="12" md="4" class="mb-50">
                <span class="font-weight-bold">收據項目：</span>
                <span v-if="refund.invoice_number">
                  [{{ refund.invoice_number }}] {{ refund.step_phase }}{{ refund.step_name ? '-' + refund.step_name : '' }} {{ refund.payment_date }} ${{ refund.amount }}
                </span>
                <span v-else>無收據項目資訊</span>
              </b-col>
              <b-col cols="12" md="4" class="mb-50">
                <span class="font-weight-bold">款項摘要：</span>
                <span class="">{{ refund.item_description || '--' }}</span>
              </b-col>
              <b-col cols="12" md="4" class="mb-50">
                <span class="font-weight-bold">退款金額：</span>
                <span class="">{{ refund.amount }}</span>
              </b-col>
            </b-row>
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                refundsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('print', 'refunds')"
                :to="{ name: 'refund-preview', params: { id: data.item.id } }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">列印收據</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'refunds')"
                :to="{
                  name: 'refund-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'refunds')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
<!--               
              <b-dropdown-item>
                <feather-icon icon="BookIcon" />
                <span class="align-middle ml-50">生成退款</span>
              </b-dropdown-item> -->

              <b-dropdown-item
                v-if="ability.can('create', 'refunds')"
                :to="{
                  name: 'refund-copy',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="CopyIcon" />
                <span class="align-middle ml-50">複製記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        </b-overlay>
      </b-card-body>
      
    </b-card>
  </div>
</template>
    
<script>
import {
  BOverlay,
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useRefundsList from "./useRefundsList";
import refundStoreModule from "../refundStoreModule";
import ModalRefundFilter from "../modal/ModalRefundFilter.vue";

export default {
  components: {
    ModalRefundFilter,
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {};
  },
  computed: {
    handleAdminReceiptOptions() {
      if (this.ability.can("admin", "receipt")) {
        return this.receiptOptions;
      } else {
        if(!this.refundsList || !this.refundsList.length){
          return [];
        } 
         const referencedReceiptIds = this.refundsList
          .map((item) => item.receipt_id)
          .filter((id) => id !== null && id !== undefined);

        // 去重
        const uniqueReceiptIds = [...new Set(referencedReceiptIds)];

        // 從 invoiceOptions 中篩選出被引用的發票
        return this.receiptOptions.filter((receipt) =>
          uniqueReceiptIds.includes(receipt.id)
        );
      }
    },
    getCreateRefundRoute() {
      // 檢查 localStorage 中的 userData.user_type_id
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      // 如果 user_type_id == 2（客戶類型），使用客戶自主退款路由
      return userData.user_type_id === 2 ? 'refund-customer-create' : 'refund-create';
    }
  },
  methods: {
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("refund/deleteRefund", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "refund";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, refundStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchRefunds,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refundsList,
      refRefundListTable,
      refetchData,
      ability,
      refetchOption,
      filter_receipt_id,
      filter_customer_id,
      filter_project_id,
      receiptOptions,
      customerOptions,
      projectOptions,
      loading,
    } = useRefundsList();

    return {
      fetchRefunds,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refundsList,
      refRefundListTable,
      refetchData,
      ability,
      refetchOption,
      filter_receipt_id,
      filter_customer_id,
      filter_project_id,
      receiptOptions,
      customerOptions,
      projectOptions,
      loading,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
    